import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './../node_modules/bulma/css/bulma.css'
import PubNubVue from 'pubnub-vue';

Vue.config.productionTip = false

Vue.use(PubNubVue, {
    subscribeKey: "sub-c-06b7ebc4-1bad-11ea-a8ee-866798696d74",
    publishKey: "pub-c-c256e768-4d5e-474c-8cfb-e35aebbd439b",
    ssl: false
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
